// extracted by mini-css-extract-plugin
export default {"trade":"Trade_trade__mL206","tradeHeader":"Trade_tradeHeader__kQFws"};